import * as React from 'react';

const MoreHoriz = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_15384_9761"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_15384_9761)">
      <path
        d="M4.15381 9C3.87881 9 3.64342 8.90206 3.44764 8.70617C3.25175 8.51039 3.15381 8.275 3.15381 8C3.15381 7.725 3.25175 7.48961 3.44764 7.29383C3.64342 7.09794 3.87881 7 4.15381 7C4.42881 7 4.66425 7.09794 4.86014 7.29383C5.05592 7.48961 5.15381 7.725 5.15381 8C5.15381 8.275 5.05592 8.51039 4.86014 8.70617C4.66425 8.90206 4.42881 9 4.15381 9ZM7.99998 9C7.72498 9 7.48959 8.90206 7.29381 8.70617C7.09792 8.51039 6.99998 8.275 6.99998 8C6.99998 7.725 7.09792 7.48961 7.29381 7.29383C7.48959 7.09794 7.72498 7 7.99998 7C8.27498 7 8.51037 7.09794 8.70614 7.29383C8.90203 7.48961 8.99998 7.725 8.99998 8C8.99998 8.275 8.90203 8.51039 8.70614 8.70617C8.51037 8.90206 8.27498 9 7.99998 9ZM11.8461 9C11.5711 9 11.3357 8.90206 11.1398 8.70617C10.944 8.51039 10.8461 8.275 10.8461 8C10.8461 7.725 10.944 7.48961 11.1398 7.29383C11.3357 7.09794 11.5711 7 11.8461 7C12.1211 7 12.3565 7.09794 12.5523 7.29383C12.7482 7.48961 12.8461 7.725 12.8461 8C12.8461 8.275 12.7482 8.51039 12.5523 8.70617C12.3565 8.90206 12.1211 9 11.8461 9Z"
        fill="#424242"
      />
    </g>
  </svg>
);

export default MoreHoriz;
